module.exports = __webpack_public_path__ + "img/caitg_metatoken.gm.95d8a4a.png";